export const UPDATE_VALUES = {
  DELETED: "Deleted",
  CLOSED: "Closed",
};
